import React from 'react';
import { Rocket, Globe, CheckCircle } from 'lucide-react';
import { specializations } from '../mock';

const iconMap = {
  Rocket: Rocket,
  Globe: Globe
};

const SpecializationsSection = () => {
  return (
    <section id="specializations" className="relative bg-white py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-5">
        <img 
          src="https://images.unsplash.com/photo-1603201667141-5a2d4c673378?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRlYW0lMjBtZWV0aW5nfGVufDB8fHx8MTc3MjI3MTg4Mnww&ixlib=rb-4.1.0&q=85"
          alt="Business Team"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block bg-[#0099FF]/10 border border-[#0099FF]/30 px-4 py-2 rounded-none mb-6">
            <span className="text-[#0099FF] text-sm font-medium">OUR SPECIALIZATIONS</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-6 tracking-tight">
            Specialized Expertise Where It Matters Most
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Whether you're a startup disrupting industries or a foreign company entering India, we have the specialized knowledge to guide you.
          </p>
        </div>

        {/* Specializations Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {specializations.map((specialization) => {
            const IconComponent = iconMap[specialization.icon];
            return (
              <div 
                key={specialization.id}
                className="group bg-gray-50 border border-gray-200 p-10 hover:border-[#0099FF]/50 hover:shadow-xl transition-all duration-400 relative overflow-hidden"
              >
                {/* Card Background Image */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-400">
                  <img 
                    src={specialization.id === 1 ? "https://images.unsplash.com/photo-1676388347933-f9bcabb86ee8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBidWlsZGluZyUyMEJhbmdhbG9yZXxlbnwwfHx8fDE3NzIyNzE4ODZ8MA&ixlib=rb-4.1.0&q=85" : "https://images.unsplash.com/photo-1576595877976-62a0b964c3af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjBidWlsZGluZyUyMEJhbmdhbG9yZXxlbnwwfHx8fDE3NzIyNzE4ODZ8MA&ixlib=rb-4.1.0&q=85"}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Icon & Title */}
                <div className="relative flex items-start gap-6 mb-6">
                  <div className="w-16 h-16 bg-[#0099FF]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#0099FF]/20 transition-all duration-400">
                    <IconComponent className="text-[#0099FF]" size={32} />
                  </div>
                  <div>
                    <h3 className="text-3xl font-semibold text-gray-900 mb-3">
                      {specialization.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {specialization.description}
                    </p>
                  </div>
                </div>

                {/* Benefits Grid */}
                <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                  {specialization.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <CheckCircle className="text-[#0099FF] flex-shrink-0 mt-1" size={20} />
                      <span className="text-gray-700 text-sm">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Stats Bar with Image Background */}
        <div className="relative grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 pt-20 border-t border-gray-200">
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#0099FF] mb-2">1500+</div>
            <div className="text-gray-600 text-sm">Clients Served</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#0099FF] mb-2">15+</div>
            <div className="text-gray-600 text-sm">Years of Excellence</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#0099FF] mb-2">100%</div>
            <div className="text-gray-600 text-sm">Satisfaction Rate</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-semibold text-[#0099FF] mb-2">200+</div>
            <div className="text-gray-600 text-sm">Startup India Projects</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializationsSection;
